window.addEventListener("DOMContentLoaded", () => {

  const initializeIncrementButtons = () => {
    const buttons = document.getElementsByName("good_button")
    const itemIdElement = document.getElementById("item_id")

    if (!itemIdElement || buttons.length === 0) {
      return
    }

    const itemId = itemIdElement.value
    const cookieName = `article_${itemId}_good_button_clicked`

    const getCookie = (name) => {
      const cookies = document.cookie.split("; ")
      for (const cookie of cookies) {
        const [key, value] = cookie.split("=")
        if (key.trim() === name) {
          return decodeURIComponent(value)
        }
      }
      return null
    }

    const setCookie = (name, value, days) => {
      const date = new Date()
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000)
      document.cookie = `${name}=${encodeURIComponent(value)}; expires=${date.toUTCString()}; path=/; SameSite=Lax`
    }

    const incrementGoodCount = async (button) => {
      if (getCookie(cookieName)) {
        return
      }

      button.disabled = true

      try {
        const response = await fetch(`/columns/${itemId}/increment_good_count`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content,
          },
        })

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`)
        }

        const data = await response.json()

        if (typeof data.count !== "number") {
          throw new Error("Invalid response data format: 'count' is not a number.")
        }

        document.getElementsByName("good_count").forEach((span) => {
          span.textContent = data.count
        })

        setCookie(cookieName, "true", 30)
      } catch (error) {
        console.error("Error occurred:", error.message)

      } finally {
        button.disabled = false
      }
    }

    buttons.forEach((button) => {
      button.addEventListener("click", () => incrementGoodCount(button))
    })

    console.log("Increment buttons initialized successfully.")
  }

  initializeIncrementButtons()
})
